import { Dispatch } from "redux"
import sbPlacementApi from "../../api/sbPlacement.api"
import { IGetSbPlacementBody, ISbBidAdjustmentItem } from "../../types/sbPlacementApi.types"
import {
  SponsoredBrandsPlacementsAction,
  SponsoredBrandsPlacementsActionType,
} from "../types/sbPlacements"
import {
  AudiencesAction,
  AudiencesActionTypes,
} from "../../../sponsoredProductsSKCAntd/store/types/audience"

const fetchSponsoredBrandsPlacements = (data: IGetSbPlacementBody) => {
  return async (dispatch: Dispatch<SponsoredBrandsPlacementsAction | AudiencesAction>) => {
    try {
      dispatch({ type: SponsoredBrandsPlacementsActionType.FETCH_SPONSORED_BRANDS_PLACEMENTS })
      const response = await sbPlacementApi.getPlacementData(data)

      dispatch({
        type: SponsoredBrandsPlacementsActionType.FETCH_SPONSORED_BRANDS_PLACEMENTS_SUCCESS,
        payload: response.data.campaigns,
      })
      dispatch({
        type: AudiencesActionTypes.FETCH_AUDIENCES_LIST_SUCCESS,
        payload: response.data.audiences,
      })
    } catch (e) {
      dispatch({
        type: SponsoredBrandsPlacementsActionType.FETCH_SPONSORED_BRANDS_PLACEMENTS_ERROR,
        payload: "sponsored brands placements load error",
      })
    }
  }
}

const resetSponsoredBrandsPlacements = () => {
  return async (dispatch: Dispatch<SponsoredBrandsPlacementsAction>) => {
    dispatch({ type: SponsoredBrandsPlacementsActionType.RESET_SPONSORED_BRANDS_PLACEMENTS })
  }
}

const setSbPlacementAdjustment = (campaignId: string, adjustment: ISbBidAdjustmentItem | null) => {
  return (dispatch: Dispatch<SponsoredBrandsPlacementsAction>) => {
    dispatch({
      type: SponsoredBrandsPlacementsActionType.SET_SB_PLACEMENT_ADJUSTMENT,
      payload: { campaignId, adjustment },
    })
  }
}

const clearSbPlacementAdjustments = () => {
  return (dispatch: Dispatch<SponsoredBrandsPlacementsAction>) => {
    dispatch({ type: SponsoredBrandsPlacementsActionType.CLEAR_SB_PLACEMENT_ADJUSTMENTS })
  }
}

const applySbAudienceToCampaigns = (campaignIds: string[], audienceId: string) => {
  return (dispatch: Dispatch<SponsoredBrandsPlacementsAction>) => {
    dispatch({
      type: SponsoredBrandsPlacementsActionType.APPLY_SB_AUDIENCE_TO_CAMPAIGNS,
      payload: { campaignIds, audienceId },
    })
  }
}

export default {
  fetchSponsoredBrandsPlacements,
  resetSponsoredBrandsPlacements,
  setSbPlacementAdjustment,
  clearSbPlacementAdjustments,
  applySbAudienceToCampaigns,
}
